import React from "react";
import * as Decorators from "../../../../styles/cell-decorators";
import DataTable from "../../../../components/data-table/data-table";

import styles from "../insights-skus.scss";
import { CategoryService } from "../../../../utils/filters";
import { LoaderWidths } from "../../../../components/tables/simple-table/simple-table";
let smallLoader = {
  loaderWidth: LoaderWidths.Small,
};

const columnsConfig = [
  {
    id: 2,
    label: "Sku",
    accessor: "skuData",
    tooltip: "",
    cellDecorator: Decorators.skuTrackerSkuDecorator,
    loaderWidth: LoaderWidths.Huge,
  },
  {
    ...smallLoader,
    id: 7,
    label: "Median Retail Price",
    accessor: "price",
    tooltip: "The Median Retail Price during the selected time period.",
    cellDecorator: Decorators.priceDecoratorWithCurrency,
  },
  {
    ...smallLoader,
    id: 8,
    label: "Retail Price Diff",
    accessor: "priceDiff",
    tooltip:
      "Percent change in Retail Price between the current time period and the previous period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 10,
    label: "Days OOS",
    accessor: "outOfStockDays",
    tooltip:
      "Number of days the product is out of stock for the competing retailer (Max 31 days)",
    cellDecorator: Decorators.defaultNumericDecorator("days_oos"),
  },
  {
    ...smallLoader,
    id: 11,
    label: "Average Rating",
    accessor: "averageRating",
    tooltip: "Average user rating for the product on the product page",
    cellDecorator: Decorators.defaultNumericDecorator("avg_rating", 1),
  },
  {
    ...smallLoader,
    id: 34,
    label: "Average Rating Diff",
    accessor: "averageRatingDiff",
    cellDecorator: Decorators.numberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 35,
    label: "Number Of Ratings",
    accessor: "numberOfRatings",
    tooltip: "The total number of ratings for a given SKU",
    cellDecorator: Decorators.numberWithCommasDecorator,
  },
  {
    ...smallLoader,
    id: 223,
    label: "Star Rating Distribution",
    accessor: "starRatingDistribution",
    tooltip:
      "Breakdown of ratings by star level (5 to 1). Hover for counts.",
    cellDecorator: Decorators.starRatingDistributionDecorator,
  },
  {
    ...smallLoader,
    id: 12,
    label: "Number Of Ratings Diff",
    accessor: "ratingCountDiff",
    tooltip:
      "The difference between the number of ratings for this SKU in the selected frequency and the previous period",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 13,
    label: "Map",
    accessor: "map",
    tooltip:
      "Minimum advertised price - taken from the customer vendor portal to compare with the retail price in the different websites. A MAP of 0 or higher indicates that the product belongs to your company.",
    cellDecorator: Decorators.priceDecorator,
  },
  {
    ...smallLoader,
    id: 14,
    label: "Map Diff",
    accessor: "mapDiff",
    tooltip:
      "The Difference between the MAP (Minimum Advertised Price) and the Retail Price",
    cellDecorator: Decorators.numberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 16,
    label: "Last Seen",
    accessor: "lastSeen",
    tooltip: "The last time we have seen this product online.",
    cellDecorator: Decorators.daysDecorator("last_seen"),
  },
  {
    ...smallLoader,
    id: 18,
    label: "Wholesale Price",
    accessor: "wholesalePrice",
    tooltip:
      "The Average Wholesale Price for the given time period (only your company's products).",
    cellDecorator: Decorators.priceDecorator,
  },
  {
    ...smallLoader,
    id: 19,
    label: "Wholesale Price Diff",
    accessor: "wholesalePriceDiff",
    tooltip:
      "Percent change in wholesale price between the current time period and the previous period (only your company's products).",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 20,
    label: "Wholesale Revenue",
    accessor: "wholesaleRevenue",
    tooltip:
      "The wholesale revenue that your company makes by the selling the product to the retailer for the given time period. (only your company's products)",
    cellDecorator: Decorators.priceDecorator,
  },
  {
    ...smallLoader,
    id: 21,
    label: "Wholesale Revenue Diff",
    accessor: "wholesaleRevenueDiff",
    tooltip:
      "Percent change in wholesale revenue between the current time period and the previous period. (only your company's products)",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 22,
    label: "Retail Sales Dollars",
    accessor: "salesDollars",
    tooltip:
      "The sales $ that the retailer makes by selling your company's product for the selected time period.",
    cellDecorator: Decorators.priceDecorator,
  },
  {
    ...smallLoader,
    id: 23,
    label: "Retail Sales Dollars Diff",
    accessor: "salesDollarsDiff",
    tooltip:
      "Percent change in retail sales dollars between the current time period and the previous period.",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 24,
    label: "Retail Margin",
    accessor: "margin",
    tooltip:
      "The percentage of total sales that the retailer can consider profit from selling your company's product",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 25,
    label: "Retail Margin Diff",
    accessor: "marginDiff",
    tooltip:
      "Percent change in retail margin between the current time period and the previous period.",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 26,
    label: "Unit Sold",
    accessor: "sales",
    tooltip: "Number of units sold for the selected time period",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 27,
    label: "Unit Sold Diff",
    accessor: "salesDiff",
    tooltip:
      "Percent units sold change between the current time period and the previous period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 28,
    label: "Sponsored Rate",
    accessor: "sponsoredRate",
    tooltip:
      "For when an item is visible (See Visibility Period), the percentage of time that a product has the sponsored tag on a retailer website.",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 29,
    label: "Sponsored Rate Diff",
    accessor: "sponsoredRateDiff",
    tooltip:
      "Percent change in sponsored rate between the current time period and the previous period.",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 30,
    label: "Rank",
    accessor: "rank",
    tooltip:
      "For when an item is visible (See Visibility Period), the median page position of a product in the first 3 pages of its relevant category and selected time period. A rank of 1 means the product is on average the first item seen.",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 31,
    label: "Rank Diff",
    accessor: "rankDiff",
    tooltip:
      "The absolute change in median rank of a product in comparison to the previous period.",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 32,
    label: "Visibility Period",
    accessor: "visibilityPeriod",
    tooltip:
      "The percent of time that an item is visibly ranked in the top results in first 3 pages (when searching using the keywords defined for that category).",
    cellDecorator: Decorators.percentageDecoratorNullAsZero,
  },
  {
    ...smallLoader,
    id: 33,
    label: "Visibility Period Diff",
    accessor: "visibilityPeriodDiff",
    tooltip:
      "The percent change in how visible a product was from the previous period to the current period for the selected time period.",
    cellDecorator: Decorators.percentChangeDecoratorNullAsZero,
  },
  {
    ...smallLoader,
    id: 117,
    label: "Last Collected Price",
    accessor: "lastCollectedPrice",
    tooltip: "The most recently collected price",
    cellDecorator: Decorators.priceDecoratorWithCurrency,
  },
  {
    ...smallLoader,
    id: 118,
    label: "Promotion Days",
    accessor: "promoDays",
    tooltip: "Promotion duration: Number of days for promotion",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 119,
    label: "Previous Visibility Period",
    accessor: "prevVisibilityPeriod",
    tooltip:
      "The percent of time that an item is visibly () ranked in the top results in first 3 pages (when searching using the keywords defined for that category) for the previous period.",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 120,
    label: "Previous Sponsored Rate",
    accessor: "prevSponsoredRate",
    tooltip:
      "For when an item is visible (See Visibility Period), the percentage of time that a product has the sponsored tag on a retailer website for the previous period.",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 121,
    label: "Region",
    accessor: "region",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 122,
    label: "State",
    accessor: "state",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 123,
    label: "Store",
    accessor: "store",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 124,
    label: "Available Units",
    accessor: "available_units",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 125,
    label: "Image Count",
    accessor: "imageCount",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 126,
    label: "Video Count",
    accessor: "videoCount",
    cellDecorator: Decorators.intDecoratorNullAsZero,
  },
  {
    ...smallLoader,
    id: 127,
    label: "Document Count",
    accessor: "documentCount",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 128,
    label: "360 View Count",
    accessor: "panoramaCount",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 129,
    label: "A+",
    accessor: "isAPlus",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 130,
    label: "Enhanced A+",
    accessor: "aPlusPremium",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 131,
    label: "Comparison Table",
    accessor: "aPlusComparison",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 132,
    label: "Videos in A+",
    accessor: "aPlusVideo",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 133,
    label: "QA",
    accessor: "aPlusFaq",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 134,
    label: "Median Regular Price",
    accessor: "listPrice",
    tooltip: "The Median Listed Price during the selected time period.",
    cellDecorator: Decorators.priceDecoratorWithCurrency,
  },
  {
    ...smallLoader,
    id: 135,
    label: "Regular Price Diff",
    accessor: "listPriceDiff",
    tooltip:
      "Percent change in Listed Price between the current time period and the previous period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 136,
    label: "Price By Unit",
    accessor: "priceByUnit",
    cellDecorator: Decorators.noDecorator,
  },
  {
    ...smallLoader,
    id: 137,
    label: "Median Used Price",
    accessor: "usedPrice",
    tooltip: "The Median Used Price during the selected time period.",
    cellDecorator: Decorators.priceDecoratorWithCurrency,
  },
  {
    ...smallLoader,
    id: 138,
    label: "Used Price Diff",
    accessor: "usedPriceDiff",
    tooltip:
      "Percent change in Used Price between the current time period and the previous period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 139,
    label: "Media Assets Score",
    accessor: "skuContentScore",
    tooltip: "SKU Media Assets Score",
    cellDecorator: Decorators.defaultNumericDecorator("media_assets_score", 2),
  },
  {
    ...smallLoader,
    id: 140,
    label: "Category Avg Content Items",
    accessor: "categoryAvgContentItems",
    tooltip: "Sku Category's Average Content Items",
    cellDecorator: Decorators.defaultNumericDecorator(
      "category_avg_content_items"
    ),
  },
  {
    ...smallLoader,
    id: 141,
    label: "Content Items Diff",
    accessor: "contentItemsDiff",
    tooltip:
      "The difference between the SKU's content items to the category's average.",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 142,
    label: "Number Of Reviews",
    accessor: "numberOfReviews",
    tooltip:
      "The total number of reviews for a given SKU",
    cellDecorator: Decorators.numberWithCommasDecorator,
  },
  {
    ...smallLoader,
    id: 143,
    label: "Seller Type",
    accessor: "sellerType",
    tooltip: "Type of seller (e.g., Amazon, Third-party)",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 144,
    label: "Ships From",
    accessor: "shipsFrom",
    tooltip: "Shipping origin location",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 145,
    label: "Is Coupon",
    accessor: "isCoupon",
    tooltip: "Whether the product currently has a coupon",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 146,
    label: "Coupon Days",
    accessor: "couponDays",
    tooltip: "Number of days with coupon for the selected time period",
    cellDecorator: Decorators.intDecorator,
  },
  {
    ...smallLoader,
    id: 150,
    label: "Discount",
    accessor: "discount",
    tooltip: "Discount percentage for the selected time period",
    cellDecorator: Decorators.percentageValueDecorator,
  },
  {
    ...smallLoader,
    id: 153,
    label: "Review Count Diff",
    accessor: "reviewCountDiff",
    tooltip: "Change in review count",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 155,
    label: "Amazon Choice Badge Ratio",
    accessor: "amazonChoiceBadgeRatio",
    tooltip: "Amazon's Choice badge appearance rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 158,
    label: "Best Seller Badge Rate",
    accessor: "bestSellerBadgeRate",
    tooltip: "Best Seller badge appearance rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 159,
    label: "Highly Rated Badge Rate",
    accessor: "highlyRatedBadgeRate",
    tooltip: "Highly Rated badge appearance rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 161,
    label: "Climate Pledge Friendly Rate",
    accessor: "climatePledgeFriendlyRate",
    tooltip: "Climate Pledge Friendly badge appearance rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 164,
    label: "Suppressed Buybox Rate",
    accessor: "suppressedBuyboxLossRate",
    tooltip: "Suppressed buybox rate for the selected time period",
    cellDecorator: Decorators.percentageDecoratorNullAsZero,
  },
  {
    ...smallLoader,
    id: 167,
    label: "Organic Rank Pos",
    accessor: "organicRankPos",
    tooltip: "Organic rank position for the selected time period",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 172,
    label: "Organic Rank Pos Diff",
    accessor: "organicRankPosDiff",
    tooltip: "Change in organic rank position for the selected time period",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 175,
    label: "Paid Rank Pos",
    accessor: "paidRankPos",
    tooltip: "Paid (sponsored) rank position for the selected time period",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 180,
    label: "Paid Rank Pos Diff",
    accessor: "paidRankPosDiff",
    tooltip: "Change in paid rank position for the selected time period",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 183,
    label: "Median Category Rank",
    accessor: "medianCategoryRank",
    tooltip: "Median category rank for the selected time period",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 186,
    label: "Median Category Rank Diff",
    accessor: "medianCategoryRankDiff",
    tooltip: "Change in median category rank for the selected time period",
    cellDecorator: Decorators.roundNumberChangeDecorator,
  },
  {
    ...smallLoader,
    id: 189,
    label: "Best Sellers Category 1 Rank",
    accessor: "bestSellersCategory1Rank",
    tooltip: "Best sellers category 1 rank for the selected time period",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 192,
    label: "Best Sellers Category 1 Name",
    accessor: "bestSellersCategory1Name",
    tooltip: "Name of the best sellers category 1",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 193,
    label: "Best Sellers Category 2 Rank",
    accessor: "bestSellersCategory2Rank",
    tooltip: "Best sellers category 2 rank for the selected time period",
    cellDecorator: Decorators.rankDecorator,
  },
  {
    ...smallLoader,
    id: 196,
    label: "Best Sellers Category 2 Name",
    accessor: "bestSellersCategory2Name",
    tooltip: "Name of the best sellers category 2",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 197,
    label: "Share Of Page 1",
    accessor: "shareOfPage1",
    tooltip: "Share of page 1 appearances for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 200,
    label: "Share Of Page 1 Diff",
    accessor: "shareOfPage1Diff",
    tooltip: "Change in share of page 1 for the selected time period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 203,
    label: "Share Of Rank Top 10",
    accessor: "shareOfRankTop10",
    tooltip: "Share of top 10 rank positions for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 206,
    label: "Share Of Rank Top 10 Diff",
    accessor: "shareOfRankTop10Diff",
    tooltip: "Change in share of top 10 for the selected time period",
    cellDecorator: Decorators.percentChangeDecorator,
  },
  {
    ...smallLoader,
    id: 209,
    label: "Search Score",
    accessor: "searchScore",
    tooltip: "Search performance score for the selected time period",
    cellDecorator: Decorators.defaultNumericDecorator("search_score", 2),
  },
  {
    ...smallLoader,
    id: 212,
    label: "Buybox Win Rate 1P",
    accessor: "buyboxWinRate1p",
    tooltip: "First-party buybox win rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 215,
    label: "Buybox Win Rate 3P",
    accessor: "buyboxWinRate3p",
    tooltip: "Third-party buybox win rate for the selected time period",
    cellDecorator: Decorators.percentageDecorator,
  },
  {
    ...smallLoader,
    id: 218,
    label: "Availability",
    accessor: "availability",
    tooltip: "Product availability status",
    cellDecorator: Decorators.yesNoDecorator,
    nullAsNo: true,
  },
  {
    ...smallLoader,
    id: 219,
    label: "Title Search Terms Score",
    accessor: "nameSearchTermsScore",
    tooltip: "Title search terms score for the SKU",
    cellDecorator: Decorators.defaultNumericDecorator("name_search_terms_score", 2),
  },
  {
    ...smallLoader,
    id: 220,
    label: "Title Length Score",
    accessor: "nameLengthScore",
    tooltip: "Title length score for the SKU",
    cellDecorator: Decorators.defaultNumericDecorator("name_length_score", 2),
  },
  {
    ...smallLoader,
    id: 221,
    label: "Title Attributes Score",
    accessor: "nameAttributesScore",
    tooltip: "Title attributes score for the SKU",
    cellDecorator: Decorators.defaultNumericDecorator("name_attributes_score", 2),
  },
  {
    ...smallLoader,
    id: 222,
    label: "Retailer Category",
    accessor: "retailerCategory",
    tooltip: "Category as displayed on the retailer's product page (might be different from category)",
    cellDecorator: Decorators.basicDecorator,
  },
  {
    ...smallLoader,
    id: 223,
    label: "Author",
    accessor: "author",
    tooltip: "Author of the product",
    cellDecorator: Decorators.basicDecorator,
  },
];

const disableTooltipForColumns = [];
var sortableColumns = [
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  117,
  118,
  119,
  120,
  124,
  125,
  126,
  127,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  139,
  140,
  141,
  142,
  146,
  150,
  153,
  155,
  158,
  159,
  161,
  164,
  167,
  172,
  175,
  180,
  183,
  186,
  189,
  192,
  193,
  196,
  197,
  200,
  203,
  206,
  209,
  212,
  215,
  218,
  219,
  220,
  221,
];

function prepareDataForTable(data) {
  const { productList, frequency: frequencyId } = data;
  const frequencyMap = ["30d", "7d", "1d"];
  const frequency = frequencyMap[frequencyId];

  const priceFrequencyMap = ["30d", "7d", ""];
  const priceFrequency = priceFrequencyMap[frequencyId];

  return productList.map((item) => {
    return {
      imageUrl: item.image,
      title: item.name,
      retailer: item.rootDomain,
      category: item.mbCategory,
      brand: item.brand,
      seller: item.topSeller,
      price: {
        price: item["price" + priceFrequency],
        rootdomain: item.rootDomain,
      },
      listPrice: {
        price: item["listPrice" + priceFrequency],
        rootdomain: item.rootDomain,
      },
      listPriceDiff: item["listPriceDiffPct" + frequency],
      usedPrice: {
        price: item["usedPrice" + priceFrequency],
        rootdomain: item.rootDomain,
      },
      usedPriceDiff: item["usedPriceDiffPct" + frequency],
      priceDiff: item["priceDiffPct" + frequency],
      promoDays:
        frequency === "1d" ? item["isPromo"] : item["promoDays" + frequency],
      numberOfRatings: item.numberOfRatings,
      numberOfReviews: item.numberOfReviews,
      visibilityPeriods: item["visibilityPeriods" + frequency],
      averageRating: item.averageRating,
      averageRatingDiff: item["averageRatingDiff" + frequency],
      ratingCountDiff: item["ratingCountDiff" + frequency],
      starRatingDistribution: item.starRatingDistribution,
      outOfStockDays: item.outOfStockDays,
      upc: item.upc,
      map: item.map,
      itemNumber: item.itemNumber,
      storeSku: item.storeSku,
      mapDiff: item.mapDiff,
      wholesalePrice: item["wholesalePrice" + frequency],
      wholesalePriceDiff: item["wholesalePriceDiff" + frequency],
      wholesaleRevenue: item["wholesaleRevenue" + frequency],
      wholesaleRevenueDiff: item["wholesaleRevenueDiff" + frequency],
      salesDollars: item["salesDollars" + frequency],
      salesDollarsDiff: item["salesDollarsDiff" + frequency],
      margin: item["margin" + frequency],
      marginDiff: item["marginDiff" + frequency],
      sales: item["sales" + frequency],
      salesDiff: item["salesDiff" + frequency],
      sponsoredRate: item["sponsoredRatio" + frequency],
      sponsoredRateDiff: item["sponsoredRatioDiff" + frequency],
      rank: item["rankPos" + frequency],
      rankDiff: item["rankPosDiff" + frequency],
      visibilityPeriod: item["visibilityPeriod" + frequency],
      visibilityPeriodDiff: item["visibilityPeriodDiff" + frequency],
      prevVisibilityPeriod: item["prevVisibilityPeriod" + frequency],
      prevSponsoredRate: item["prevSponsoredRatio" + frequency],
      lastSeen: item.lastSeen,
      mpn: item.mpn,
      lastCollectedPrice: { price: item.price, rootdomain: item.rootDomain },
      region: item.region,
      state: item.state,
      store: item.store,
      available_units: item.availableUnits,
      imageCount: item.imageCount,
      videoCount: item.videoCount,
      documentCount: item.documentCount,
      panoramaCount: item.panoramaCount,
      isAPlus: item.isAPlus,
      aPlusPremium: item.aPlusPremium,
      aPlusComparison: item.aPlusComparison,
      aPlusVideo: item.aPlusVideo,
      aPlusFaq: item.aPlusFaq,
      priceByUnit: item.priceByUnit,
      skuContentScore: item.skuContentScore,
      categoryAvgContentItems: item.categoryAvgContentItems,
      contentItemsDiff: item.contentItemsDiff,
      sellerType: item.sellerType,
      shipsFrom: item.shipsFrom,
      isCoupon: item.isCoupon,
      couponDays: frequency === "1d" ? item["isCoupon"] : item["couponDays" + frequency],
      discount: item["discount" + frequency],
      reviewCountDiff:  item["reviewCountDiff" + frequency],
      amazonChoiceBadgeRatio: item["amazonChoiceBadgeRatio" + frequency],
      bestSellerBadgeRate: item["bestSellerBadgeRate" + frequency],
      highlyRatedBadgeRate: item["highlyRatedBadgeRate" + frequency],
      climatePledgeFriendlyRate: item["climatePledgeFriendlyRate" + frequency],
      suppressedBuyboxLossRate: item["suppressedBuyboxLossRate" + frequency],
      organicRankPos: item["organicRankPos" + frequency],
      organicRankPosDiff: item["organicRankPosDiff" + frequency],
      paidRankPos: item["paidRankPos" + frequency],
      paidRankPosDiff: item["paidRankPosDiff" + frequency],
      medianCategoryRank: item["medianCategoryRank" + frequency],
      medianCategoryRankDiff: item["medianCategoryRankDiff" + frequency],
      bestSellersCategory1Rank: item["bestSellersCategory1Rank" + frequency],
      bestSellersCategory1Name: item.bestSellersCategory1Name1d,
      bestSellersCategory2Rank: item["bestSellersCategory2Rank" + frequency],
      bestSellersCategory2Name: item.bestSellersCategory2Name1d,
      shareOfPage1: item["shareOfPage1" + frequency],
      shareOfPage1Diff: item["shareOfPage1Diff" + frequency],
      shareOfRankTop10: item["shareOfRankTop10" + frequency],
      shareOfRankTop10Diff: item["shareOfRankTop10Diff" + frequency],
      searchScore: item["searchScore" + frequency],
      buyboxWinRate1p: item["buyboxWinRate1p" + frequency],
      buyboxWinRate3p: item["buyboxWinRate3p" + frequency],
      availability: item.availability,
      nameSearchTermsScore: item.nameSearchTermsScore,
      nameLengthScore: item.nameLengthScore,
      nameAttributesScore: item.nameAttributesScore,
      retailerCategory: item.retailerCategory,
      author: item.author,
      skuData: {
        name: item.name,
        image: item.image,
        sku: item.sku,
        brand: item.brand,
        retailer: item.rootDomain,
        topSeller: item.topSeller,
        upc: item.upc,
        mpn: item.mpn,
        itemNumber: item.itemNumber,
        storeSku: item.storeSku,
        productType: CategoryService.getCategoryLeaf(item.mbCategory),
        variantAttributes: item.variantAttributes,
      },
    };
  });
}

function TopSkusTable(props) {
  const data = {
    productList: props.productList,
    frequency: props.frequency,
  };

  return (
    <>
      <DataTable
        header="SKU Tracker"
        columnsConfig={columnsConfig}
        onSaveSelectedColumns={props.onSaveSelectedColumns}
        excludedTableColumns={props.excludedTableColumns}
        sorting={props.sorting}
        selectedColumns={props.selectedColumns}
        sortableColumns={sortableColumns}
        disableTooltipForColumns={disableTooltipForColumns}
        prepareSortingValues={props.prepareSortingValues}
        prepareDataForTable={prepareDataForTable}
        onSelectRow={props.onSelectRow}
        styles={styles}
        data={data}
        isLoading={props.isLoading}
        isSticky={true}
      />
    </>
  );
}

export default TopSkusTable;
